module.exports = __webpack_public_path__ + "static/sheila.ce2e4388.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/sheila.jpg
// module id = 542
// module chunks = 263791100135453